import * as yup from 'yup'

const schemaCompanyDestroy = () =>
  yup.object().shape({
    description: yup.string().trim().required(),
  })

export default schemaCompanyDestroy
